import React, { useEffect, useState } from "react";
import L from "leaflet";
import { MapContainer, TileLayer, Polyline, Polygon, Circle, Popup, useMap, Marker } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import RoutingMachine from "./RoutingMachine";
import useHttp from "../../../hook/use-http";
import { API_URL_MAIN } from "../../../constants/driveglobalfilterinitalstates";

// const VectorLayersMap = ({ jsonData, selectedViews }) => {
const VectorLayersMap = ({ selectedViews, gloablfilter }) => {
  const { isLoading, error, sendReq: fetchData } = useHttp();
  const [jsonData, setJsonData] = useState({})
  const [polyGoneColor, setPolyGoneColor] = useState("")

  const appyData = (data) => {
    if (data?.State_of_Charge_SOC !== undefined) {
      const newColor = data.State_of_Charge_SOC <= 30 ? "red" : "#358696";
      setPolyGoneColor(newColor);
    }
    setJsonData(data);
  };

  useEffect(() => {
    fetchData(
      {
        url: API_URL_MAIN + "real_time_fault_code/range_polygon",
        body: { filterdata: gloablfilter },
      },
      appyData
    );
  }, [gloablfilter]);

  const carIcon = new L.Icon({
    iconUrl: "/assets/img/car_repair_black_24dp 2.png", // No "./" or "../"
    iconSize: [30, 30],
  });

  const chargingIcon = new L.Icon({
    iconUrl: "/assets/img/highlightsKpi/slow_dynamic_bms_max_cell_voltage.svg",
    iconSize: [30, 30],
  });

  const defaultPosition = [jsonData?.Latitude, jsonData?.Longitude];

  const calculateZoom = (batterySOC) => {
    if (batterySOC >= 100) return 8;
    if (batterySOC >= 90) return 9;
    if (batterySOC >= 80) return 10;
    if (batterySOC >= 60) return 11;
    if (batterySOC >= 40) return 12;
    if (batterySOC >= 20) return 13;
    return 14; // Very low battery → zoomed in more
  };

  // Dynamically calculate zoom level
  // const zoomLevel = calculateZoom(jsonData?.Distance_to_Empty);
  let zoomLevel;
  (selectedViews.includes("polygon")) ? zoomLevel = calculateZoom(100) : zoomLevel = calculateZoom(60)

  const polygonVertices = jsonData?.Vertices;
  const chargingStations = jsonData?.Charging_stations;
  const nearestStation = jsonData?.Nearest_charging_station;
  // (jsonData.State_of_Charge_SOC <= 30) ? setPolyGoneColor("red") : setPolyGoneColor("#358696")
  // const clr = (jsonData.State_of_Charge_SOC <= 30) ? "red" : "#358696"

  // Define polyline coordinates (line)
  const polylineCoords = [
    [51.505, -0.09],
    [51.51, -0.1],
    [51.52, -0.12],
  ];

  // Define polygon coordinates (area)
  const polygonCoords = [
    [51.51, -0.08],
    [51.52, -0.06],
    [51.53, -0.07],
  ];

  const ResetView = ({ center, zoom }) => {
    const map = useMap();

    useEffect(() => {
      map.setView(center, zoom);
    }, [center, zoom, map]);

    return null;
  };

  // Define circle center and radius
  // const circleCenter = [51.508, -0.11];
  // const circleRadius = 500; // in meters

  return (
    jsonData?.Latitude && jsonData?.Longitude ? (
      // <MapContainer center={[51.505, -0.09]} zoom={13} style={{ height: "500px", width: "100%" }}>
      <MapContainer center={defaultPosition} zoom={zoomLevel} style={{ height: "485px", width: "100%" }}>
        <ResetView center={defaultPosition} zoom={zoomLevel} />
        {/* Tile Layer (Base Map) */}
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        // attribution="&copy; OpenStreetMap contributors"
        />

        {/* org code working */}
        {/* Polyline */}
        {/* <Polyline positions={polylineCoords} color="blue">
        <Popup>Polyline Example</Popup>
      </Polyline> */}

        {/* Polygon */}
        {/* <Polygon positions={polygonCoords} color="green">
        <Popup>Polygon Example</Popup>
      </Polygon> */}

        {/* Circle */}
        {/* <Circle center={circleCenter} radius={circleRadius} color="red">
        <Popup>Circle Example</Popup>
      </Circle> */}
        {/* org code working */}
        {selectedViews.includes("vehicle") && (
          <Marker position={defaultPosition} icon={carIcon}>
            <Popup>{`Vehicle Location\nBattery: ${jsonData?.Battery_SOC}%`}</Popup>
          </Marker>
        )}

        {selectedViews.includes("polygon") && (
          < Polygon key={polyGoneColor} positions={polygonVertices} color={polyGoneColor} fillOpacity={0.2}>
            {/* <Popup>Range Polygon (100 km)</Popup> */}
          </Polygon>
        )}

        {
          selectedViews.includes("charging") &&
          chargingStations.map((station, index) => (
            <Marker key={index} position={[station[1], station[0]]} icon={chargingIcon}>
              <Popup>Charging Station</Popup>
            </Marker>
          ))
        }

        {/* {selectedViews.includes("nearest") && (
        <>
          <Marker position={[nearestStation[1], nearestStation[0]]} icon={chargingIcon}>
            <Popup>{`Nearest Charging Station\n${jsonData.Nearest_charging_station_address}`}</Popup>
          </Marker>
          <Polyline positions={[defaultPosition, [nearestStation[1], nearestStation[0]]]} color="red">
            <Popup>Route to Nearest Charging Station</Popup>
          </Polyline>
        </>
      )} */}

        {
          selectedViews.includes("nearest") && (
            <>
              <Marker position={[nearestStation[1], nearestStation[0]]} icon={chargingIcon}>
                <Popup>{`Nearest Charging Station\n${jsonData?.Nearest_charging_station_address}`}</Popup>
              </Marker>

              (
              {

                (nearestStation[1] && nearestStation[0]) &&
                <RoutingMachine carLocation={defaultPosition} chargingStation={[nearestStation[1], nearestStation[0]]} />
              }
              )
            </>
          )
        }

      </MapContainer >
    ) : (
      <p>Please Enter a Vin / Chassis No.</p>
    )
  );
};

export default VectorLayersMap;
